import routes from "../routes/routes";

const navigationLinks = [
    { name: "Présentation", href: routes.presentation },
    { name: "Comités", href: routes.comites },
    { name: "Politique de publication", href: routes.politique },
    { name: "Crédits", href: routes.credits },
    { name: "Proposer un article", href: routes.proposition }
];

export default navigationLinks;